var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkPermissionSlug(['settings_list']))?_c('div',{staticClass:"p-6 vx-row"},[_c('div',{staticClass:"vx-col p-6 w-full"},[_c('Policy')],1),_c('div',{staticClass:"vx-col p-6 w-1/2"},[_c('CustomerSupport')],1),_c('div',{staticClass:"vx-col p-6 w-1/2"},[_c('ProfileBannerImage')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }